import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { REQUEST_ACTIONS, STATUS } from '~/Constants/Actions.constants';
import { TIME_VALUES } from '~/Constants/Date.constants';
import { PROVIDER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { routeReplacer } from '~/Helpers/String.helper';
import { useProvider } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { ILocation } from '~/Models/DTO/Location.models';
import { selectLocationList } from '~/store/provider';
import { LocationStatus } from '~/Models/DTO/externalParties.model';

const LocationStatusMap = {
  0: LocationStatus.Inactive,
  1: LocationStatus.AwaitingApproval,
  2: LocationStatus.Active,
  3: LocationStatus.Paused,
  4: LocationStatus.Terminated,
};

export const useRequestLocationList = (defaultQuery: { [name: string]: any }) => {
  const { currentProvider } = useProvider();
  const dispatch = useDispatch();
  const locationListRedux = useSelector(selectLocationList);

  return useQuery<ILocation[], IErrorResponse>(
    [REQUEST_ACTIONS.LOCATION_LIST, defaultQuery.domain, currentProvider?.uuid, locationListRedux],
    async () => {
      let data = await requestReactQuery<ILocation[]>({
        url: routeReplacer(PROVIDER_SERVICE_URLS.LOCATION_LIST, {
          providerUUID: currentProvider?.uuid || '',
        }),
        params: { ...defaultQuery, pageSize: 1000, page: 1 },
        config: { method: 'GET' },
      });
      data = data?.map((location: ILocation) => ({
        ...location,
        status: typeof location?.state === 'number' ? LocationStatusMap[location?.state] : null,
      })) as any;
      return data;
    },
    {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: TIME_VALUES.HOUR,
      initialData: [],
      onSuccess: (data) => {
        dispatch({
          type: REQUEST_ACTIONS.LOCATION_LIST,
          name: REQUEST_ACTIONS.LOCATION_LIST,
          status: STATUS.SUCCESS,
          payload: data,
        });
      },
    },
  );
};
